<template>
  <div class="StepOne">
     <el-form label-position="right" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="公司名称：">
                <el-input class="input" v-model="formType.companyname" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="注册资本：">
                <!-- <el-input style="width: 320px;" v-model="formType.netprice" placeholder="请输入"></el-input> -->
                <el-input class="input txt" v-model="formType.regcapital" placeholder="请填写公司注册资本" maxlength="8"></el-input>
                <span class="tips_span">万元</span>
                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">注册资本默认为公司总股本</div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>
            </el-form-item>
        </el-form>
    <div class="animated fadeInUp btnlist">
        <!-- <el-button @click="bbbbbbb" type="primary" plain>上一步</el-button> -->
        <el-button @click="next" type="primary">下一步</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StepOne',
  props: ['formType'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    next() {
      if (this.formType.companyname.length == 0) {
        this.$message.warning('请输入公司名称')
      } else if (this.formType.regcapital.length == 0) {
        this.$message.warning('请填写公司注册资本')
      } else if (this.formType.regcapital < 1 || this.formType.regcapital > 10000000) {
        this.$message.warning('公司注册资本在 1 - 10000000 之间')
      } else if (!/^[0-9]+\.{0,1}[0-9]{0,2}$/.test(this.formType.regcapital)) {
        this.$message.warning('请填写正确的公司注册资本(两位小数内的整数)')
      } else {
        this.$emit('setStepValue', 1)
      }
    }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
    
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.StepOne {
  margin-top: 50px;
  background-color: #fff;
  .el-form {
    padding-left: 200px;
  }
}
</style>